import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Container } from '@nfs-react/components';
import { useImg, useText } from 'hooks';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';
import {
  Button,
  ChangeableBackgroundSection,
  ChangeableButtonBg,
} from 'helpers/components';

const CTA = ({
  openPopup,
}) => {

  return (
    <ChangeableBackgroundSection
      id='cta-background'
      defaultStyle={{ backgroundColor: 'transparent' }}
    >
      <Wrapper>
        <CTAContainer>
          <ChangeableButtonBg
            id="cta-background-btn"
            defaultColor="#8cc23c"
            buttonContainerCss={buttonContainerStyles}
          >
            <Button
              buttonCss={buttonStyles}
              clickHandler={openPopup}
            >
              {useText('bottom__button', true)}
            </Button>
          </ChangeableButtonBg>
            <Logos>
              {useImg('cta_visa.webp', 'visa')}
              {useImg('cta_visa_el.webp', 'visa_el')}
              {useImg('cta_maestro.webp', 'maestro')}
              {useImg('cta_mastercard.webp', 'mastercard')}
              {useImg('cta_skrill.webp', 'skrill')}
              {useImg('cta_neteller.webp', 'neteller')}
            </Logos>
        </CTAContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const Wrapper = styled.div`
  @media ${DESKTOP} {
    padding: 0 0 40px;
  }

  @media ${TABLET} {
    padding: 40px 0;
  }
`;

const CTAContainer = styled(Container)`
  text-align: center;
`;

const buttonContainerStyles = css`
  @media ${MOBILE} {
    width: 100%;
  }
`;

const buttonStyles = css`
  display: inline-flex;
  border-radius: 35px;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-align: center;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
  padding: 5px 25px;
  cursor: pointer;
  box-shadow: 0px 4.51487px 10.1585px rgba(0, 0, 0, 0.18);
  border: none;
  outline: none;
  border-radius: 0;

  @media ${DESKTOP} {
    min-height: 70px;
    font-size: 19px;
    line-height: 24px;
    min-width: 360px;
    width: 100%;
    margin-bottom: 36px;
    &:hover {
      transform: scale(1.08);
    }
  }

  @media ${TABLET} {
    font-size: 19px;
    line-height: 22px;
    min-width: 360px;
    min-height: 70px;
    margin-bottom: 24px;
    &:active {
      transform: scale(1.08);
    }
  }

  @media ${MOBILE} {
    display: flex;
    font-size: 17px;
    line-height: 21px;
    min-height: 70px;
    width: 100%;
    &:active {
      transform: scale(1.08);
    }
  }
`;

const Logos = styled.div`
  display: flex;
  width: 750px;
  margin: 32px auto;
  justify-content: space-between;
  align-items: center;

  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;

    @media ${TABLET} {
      max-width: 259px;
    }

    @media ${MOBILE} {
      max-width: 328px;
    }
  }

  @media ${MOBILE} {
    max-width: 340px;
    flex-wrap: wrap;
    gap: 4px;
    row-gap: 40px;
    justify-content: center;

    div {
      width: 26%;
      min-height: 40px;
    }
  }
`;
CTA.propTypes = {
  openPopup: PropTypes.func.isRequired,
};

export default CTA;
